<template>
    <div>
        <div class="page">
            <!-- 筛选 -->
            <div class="total f-r-sbc">
                <div class="total-left">
                    选择匹配范围
                </div>
                <div class="total-right f-r-se"></div>
            </div>
            <div class="filter" :style="{ marginTop: '30px' }">
                <!-- @keyup.enter.native="searchQuery" -->
                <Form :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
                    <Row :gutter="24">
                        <Col :span="8">
                            <Item label="发布年份">
                                <JMultiSelectTag
                                    :style="{ width: '100%' }"
                                    placeholder="请选择发布年份"
                                    v-model="form.hasStartTime"
                                    :options="yearList"
                                >
                                </JMultiSelectTag>
                            </Item>
                        </Col>

                        <Col :span="8">
                            <Item label="政策级别">
                                <JMultiSelectTag
                                    :style="{ width: '100%' }"
                                    placeholder="请选择政策级别"
                                    v-model="form.policyLevel"
                                    :filter-option="false"
                                    :options="policyLevelList"
                                >
                                </JMultiSelectTag>
                            </Item>
                        </Col>

                        <Col :span="8">
                            <Item label="扶持方向">
                                <Select
                                    :style="{ width: '100%' }"
                                    placeholder="请选择扶持方向"
                                    mode="multiple"
                                    show-search
                                    :filter-option="false"
                                    @search="dirSearch"
                                    @change="dirChange"
                                >
                                    <Option v-for="item in dirList" :key="item.id" :value="item.id">
                                        {{ item.name }}
                                    </Option>
                                </Select>
                            </Item>
                        </Col>

                        <Col :span="8">
                            <Item label="所属行业">
                                <Select
                                    :style="{ width: '100%' }"
                                    placeholder="请选择所属行业"
                                    mode="multiple"
                                    show-search
                                    :filter-option="false"
                                    @search="busSearch"
                                    @change="busChange"
                                >
                                    <Option v-for="item in busList" :key="item.id" :value="item.id">
                                        {{ item.name }}
                                    </Option>
                                </Select>
                            </Item>
                        </Col>
                        <Col :xl="6" :lg="7" :md="8" :sm="24">
                            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                                <Button type="primary" @click="searchQuery" icon="search">筛选</Button>
                                <Button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px"
                                    >重置</Button
                                >
                            </span>
                        </Col>
                    </Row>
                </Form>
            </div>

            <!-- 列表 -->
            <div class="total f-r-sbc" :style="{ marginTop: '10px' }">
                <div class="total-left">
                    开始答题匹配
                </div>
                <!-- <div class="total-right f-r-se" @click="toMatch">
                    重新匹配
                </div> -->
            </div>

            <div class="question-list">
                <div class="item" v-for="(item, index) in questionList" :key="item.id">
                    <div class="title">{{ index + 1 }}: {{ item.question }}</div>
                    <div class="finish" v-if="item.isAns == 0">未答题</div>
                    <div class="unfinish" v-else>已完成</div>

                    <div class="answer" v-if="item.isAns == 0" @click="toItem(item.id)">开始答题</div>
                    <div class="answer" v-else @click="toItem(item.id)">重新答题</div>
                </div>
            </div>

            <div class="pagination">
                <Pagination
                    :defaultPageSize="form.pageSize"
                    size="large"
                    show-quick-jumper
                    :default-current="1"
                    :total="total"
                    @change="onChange"
                ></Pagination>
            </div>
        </div>
    </div>
</template>

<script>
import JMultiSelectTag from "@/components/JMultiSelectTag";
import { Message } from "ant-design-vue";
import { getAction, postAction } from "@/util/require.js";
export default {
    name: "",
    components: {
        JMultiSelectTag
    },
    data() {
        return {
            list: [],
            total: 0,

            form: {
                pageNo: 1,
                pageSize: 5
            },
            dirList: [],
            busList: [],

            yearList: [
                {
                    label: "2021",
                    value: "2021"
                },
                {
                    label: "2020",
                    value: "2020"
                },
                {
                    label: "2019",
                    value: "2019"
                },
                {
                    label: "2018",
                    value: "2018"
                }
            ],
            policyLevelList: [
                {
                    label: "国家级",
                    value: "国家级"
                },
                {
                    label: "福建省级",
                    value: "福建省级"
                },
                {
                    label: "福州市级",
                    value: "福州市级"
                },
                {
                    label: "高新区级",
                    value: "高新区级"
                }
                // {
                //     label: "市企业家大会",
                //     value: "市企业家大会"
                // }
            ],
            questionList: []
        };
    },
    created() {
        this.getDirList();
        this.getBusList();
        this.loadData();
    },
    mounted() {},
    methods: {
        onChange(e) {
            this.loadData(e);
        },
        dirSearch(e) {
            this.getDirList(e);
        },
        dirChange(data) {
            this.form.dirId = data.join(",");
        },
        busChange(data) {
            this.form.busId = data.join(",");
        },
        busSearch(e) {
            this.getBusList(e);
        },
        searchQuery() {
            this.loadData(1);
        },
        searchReset() {
            this.form = {
                pageNo: 1,
                pageSize: 5
            };
            this.loadData(1);
        },
        loadData(arg) {
            if (arg) {
                this.form.pageNo = arg;
            }
            getAction("/hq/webPage/questionLists", { ...this.form }).then(res => {
                if (res.success) {
                    this.questionList = res.result.records;
                    this.total = res.result.total;
                } else {
                    Message.warning(res.message);
                }
            });
        },
        getDirList(content) {
            let param = {};
            if (content) {
                param.content = content;
            }
            getAction("/hq/webPage/getDirList", param).then(res => {
                if (res.success) {
                    this.$set(this, "dirList", res.result);
                } else {
                    Message.warning(res.message);
                }
            });
        },
        getBusList(content) {
            let param = {};
            if (content) {
                param.content = content;
            }
            getAction("/hq/webPage/getBusList", param).then(res => {
                if (res.success) {
                    this.$set(this, "busList", res.result);
                } else {
                    Message.warning(res.message);
                }
            });
        },
        toItem(id) {
            this.$router.push({ path: "/policyMatch/questionItem", query: { itemId: id } });
        },
        toMatch() {
            this.$router.push({ path: "/policyMatch" });
        }
    }
};
</script>

<style scoped lang="scss">
.page {
    min-height: 500px;
    width: 1200px;
}
$mainColor: #087ce8;
.total {
    margin-top: 90px;
    width: 100%;
    padding: 0 0 9px 0;
    border-bottom: 2px dashed $mainColor;
    .total-left {
        text-indent: 10px;
        font-size: 28px;
        line-height: 28px;
        font-family: PingFang SC;
        font-weight: bold;
        color: $mainColor;
        position: relative;
        &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            height: 28px;
            width: 4px;
            background: $mainColor;
        }
    }
    .total-right {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #087ce8;
        cursor: pointer;
        &:hover {
            text-decoration: underline;
        }
    }
}
.question-list {
    min-height: 500px;
    .item {
        padding: 40px 0 23px;
        display: flex;
        flex-direction: row;
        align-items: center;
        border-bottom: 1px solid #e5e5e5;
        position: relative;
    }
    .title {
        max-width: 800px;
        font-size: 24px;
        font-weight: 400;
        color: #333333;
        line-height: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .finish {
        margin-left: 10px;
        width: 60px;
        height: 24px;
        background: rgba(8, 124, 232, 0.1);
        border-radius: 12px;
        font-size: 14px;
        font-weight: bold;
        color: #087ce8;
        text-align: center;
        line-height: 24px;
    }
    .unfinish {
        margin-left: 10px;
        width: 60px;
        height: 24px;
        background: #ff0012;
        border-radius: 12px;
        font-size: 14px;
        font-weight: bold;
        color: #ffffff;
        text-align: center;
        line-height: 24px;
    }

    .answer {
        font-size: 24px;
        line-height: 1;
        font-weight: 500;
        color: #087ce8;
        position: absolute;
        cursor: pointer;
        right: 0;
        &:hover {
            text-decoration: underline;
        }
    }
}
.pagination {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 100px 0 120px;
    width: 1200px;
}

::v-deep .ant-form label {
    font-size: 16px;
}
</style>
